import { httpGet, httpPost, httpDownload } from "../../../../utils/api.utils";
import { actions } from "react-redux-form";
import Moment from 'moment';

import {
    getOutputConfigurationDropdownlist
    , outputConfigurationDropdownListModel
    , multipleOutputColumnScopeModel
    , outputConfigurationModel
    , circuitOutputScopeModel
    , equipmentOutputScopeModel
    , otcOutputScopeModel
    , outputColumnScopeModel
    , filterOperatorByType
    , deleteOutputScopeData
    , addUpdateScopeItem
    , resetDataTable
    , addUpdateOutputColumnItem
    , deleteOutputColumnData
    , updateOutputColumnsDatatable
    , getOutputConfigurationDetails
    , filterColumnFormatByType
    , filterMultipleColumn1FormatByType
    , filterMultipleColumn2FormatByType
    , filterMultipleColumn3FormatByType
    , getUpdateOutputScopeCount
} from "../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration-details.settings"
import { COLUMN_DATA_TYPE, FILE_DELIMITER, OPERATOR_FILTERS, RECHARGE_INVENTORY_TYPE, OUTPUT_SCOPE_TYPE, OUTPUT_COLUMN_TYPE, OPERATOR_FILTER_ENUMS } from "../../../../constants/external-constants";
import { convertToTimeZoneDate, convertToFormatTimeZoneDate, toPascalCase } from "../../../../utils/helpers.utils";

import { batch } from "react-redux";

export const outputConfigurationInitialState = outputConfigurationModel;
export const circuitOutputScopeInitialState = circuitOutputScopeModel;
export const equipmentOutputScopeInitialState = equipmentOutputScopeModel;
export const otcOutputScopeInitialState = otcOutputScopeModel;
export const outputColumnScopeInitialState = outputColumnScopeModel;
export const multipleOutputColumnScopeModelInitialState = multipleOutputColumnScopeModel;

const defaultState = () => ({
    isOutputConfigurationDropdownListLoaded: false
    , outputConfigurationDropdownlist: outputConfigurationDropdownListModel
    , filterOperatorOptions: []
    , filterType: ''
    , filterColumnFormat: []
    , filterColumn1Format: []
    , filterColumn2Format: []
    , filterColumn3Format: []
    , circuitDataTable: {
        dataTable: []
    }
    , equipmentDataTable: {
        dataTable: []
    }
    , otcDataTable: {
        dataTable: []
    }
    , outputColumnsDatatable: {
        dataTable: []
    }
    , multipleOutputColumnsDatatable: {
        dataTable: []
    }
})

const initialState = defaultState();

export const OutputConfigurationDetailsActions = {
    getOutputConfigurationDropdownlist: () => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getOutputConfigurationDropdownList');

        if (res) {
            dispatch({
                type: getOutputConfigurationDropdownlist
                , isOutputConfigurationDropdownListLoaded: true
                , outputConfigurationDropdownlist: Object.keys(res).length > 0 ? res : outputConfigurationDropdownListModel
            })
        }
        else {
            dispatch({
                type: getOutputConfigurationDropdownlist
                , isOutputConfigurationDropdownListLoaded: false
                , isOutputConfigurationDropdownListError: false
            })
        }
    },

    addUpdateScopeItem: (outputScope) => (dispatch, state) => {
        const {
            outputConfigurationDetails: {
                outputConfigurationDropdownlist: {
                    CircuitColumnSource,
                    EquipmentColumnSource,
                    OtcColumnSource,
                    SearchOperator,
                    ConditionalOption,
                },
                //outputScopeCircuitDatatable: circuitDataTable,
                circuitDataTable: {
                    dataTable: circuitDataTable
                },
                equipmentDataTable: {
                    dataTable: equipmentDataTable
                },
                otcDataTable: {
                    dataTable: otcDataTable
                },
            },
            form: {
                outputConfigurationDetailsForm: {
                    circuitOutputScope,
                    equipmentOutputScope,
                    otcOutputScope,
                },
            },
            adminSetting: {
                activeTimeZoneOffset
            }
        } = state();

        const SCOPE_MAP = {
            [RECHARGE_INVENTORY_TYPE.Circuit.id]: {
                columnSource: CircuitColumnSource,
                scopeData: circuitOutputScope,
                scopeList: circuitDataTable
            },
            [RECHARGE_INVENTORY_TYPE.Equipment.id]: {
                columnSource: EquipmentColumnSource,
                scopeData: equipmentOutputScope,
                scopeList: equipmentDataTable
            },
            [RECHARGE_INVENTORY_TYPE.OTC.id]: {
                columnSource: OtcColumnSource,
                scopeData: otcOutputScope,
                scopeList: otcDataTable
            }
        };

        const { columnSource, scopeData, scopeList } = SCOPE_MAP[outputScope] || {};
        const updatedScopeList = scopeList[0]?.dataItem ?? []

        const {
            ID,
            FilterID,
            OperatorID,
            OptionID,
            StartDateValue,
            EndDateValue,
            DateValue,
            Value,
        } = scopeData;

        const column = columnSource.find(f => f.FilterId === parseInt(FilterID));
        const operator = SearchOperator.find(x => x.Key === parseInt(OperatorID));
        const option = ConditionalOption.find(x => x.Key === parseInt(OptionID));

        const now = Moment();
        const formattedNow = `${now.format('L')} ${now.format('LT')}`;
        const lastModified = `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`;

        const newItem = {
            ...scopeData,
            ID: -1,
            FilterID: parseInt(FilterID),
            FilterName: column?.FilterName,
            OperatorName: operator?.Value,
            OperatorID: parseInt(OperatorID),
            OptionName: option?.Value,
            OptionID: parseInt(OptionID),
            Value: Value,
            Date: parseInt(OperatorID) === 1 && StartDateValue != null
                ? `${StartDateValue} - ${EndDateValue}`
                : DateValue,
            DateValue: DateValue,
            StartDateValue: StartDateValue,
            EndDateValue: EndDateValue,
            CreatedByUserID: sessionStorage.getItem('UserRoleID'),
            CreatedDate: formattedNow,
            LastModified: lastModified
        };

        let updatedScopeData = [...updatedScopeList];

        if (ID >= 0 && updatedScopeData[ID]) {
            updatedScopeData[ID] = {
                ...updatedScopeData[ID],
                ID,
                FilterID: parseInt(FilterID),
                FilterName: column?.FilterName,
                OperatorID: parseInt(OperatorID),
                OperatorName: operator?.Value,
                OptionID: parseInt(OptionID),
                OptionName: option?.Value,
                Value: Value,
                Date: parseInt(OperatorID) === 1 && StartDateValue != null
                        ? `${StartDateValue} - ${EndDateValue}`
                        : DateValue,
                DateValue,
                StartDateValue,
                EndDateValue,
                CreatedByUserID: sessionStorage.getItem('UserRoleID'),
                CreatedDate: formattedNow,
                LastModified: lastModified
            };
        }

        const newDataTable = [{
            dataItem: ID >= 0 && updatedScopeData[ID] ? updatedScopeData : [...updatedScopeList, newItem],
            headerItem: []
        }];

        if (outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id) {
            dispatch({
                type: addUpdateScopeItem,
                circuitDataTable: newDataTable,
                filterOperatorOptions: []
            });
        } else if (outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id) {
            dispatch({
                type: addUpdateScopeItem,
                equipmentDataTable: newDataTable,
                filterOperatorOptions: []
            });
        } else {
            dispatch({
                type: addUpdateScopeItem,
                otcDataTable: newDataTable,
                filterOperatorOptions: []
            });
        }
    },

    viewOutputScope: (index, outputScope) => async (dispatch,state) => {
        const { circuitDataTable, equipmentDataTable, otcDataTable } = state().outputConfigurationDetails;

        const fetchData = outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id
                ? circuitDataTable
                : outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id
                    ? equipmentDataTable
                    : otcDataTable;

        const data = await fetchData.dataTable[0].dataItem[index];

        const dataItem = {
            ...data,
            ID: index,
            ...(data.Date != null ? {DateValue: new Date(data.Date)} : null),
            ...(data.StartDateValue != null ? {StartDateValue: new Date(data.StartDateValue)} : null),
            ...(data.EndDateValue != null ? {EndDateValue: new Date(data.EndDateValue)} : null),
        };

        if (outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id) {
            dispatch(actions.reset("outputConfigurationDetailsForm.circuitOutputScope"));
            dispatch(actions.change("outputConfigurationDetailsForm.circuitOutputScope", dataItem));
        }
        else if (outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id) {
            dispatch(actions.reset("outputConfigurationDetailsForm.equipmentOutputScope"));
            dispatch(actions.change("outputConfigurationDetailsForm.equipmentOutputScope", dataItem));
        }
        else {
            dispatch(actions.reset("outputConfigurationDetailsForm.otcOutputScope"));
            dispatch(actions.change("outputConfigurationDetailsForm.otcOutputScope", dataItem));
        }

        const { filterType, filterOperator } = getSearchOperators(outputScope, dataItem.FilterID, state);

        if (filterOperator) {
            dispatch({
                type: filterOperatorByType
                , filterOperatorOptions: filterOperator
                , filterType: filterType
            })
        }
    },

    deleteOutputScopeData: (index, outputScope) => (dispatch, state) => {
        const { circuitDataTable, equipmentDataTable, otcDataTable } = state().outputConfigurationDetails;

        const circuitScopeList = circuitDataTable?.dataTable[0]?.dataItem;
        const equipmenttScopeList = equipmentDataTable?.dataTable[0]?.dataItem;
        const otcScopeList = otcDataTable?.dataTable[0]?.dataItem;

        var circuitDataItem = circuitScopeList
        var equipmentDataItem = equipmenttScopeList
        var otcDataItem = otcScopeList
        var HeaderItem = []

        if (parseInt(outputScope) === parseInt(RECHARGE_INVENTORY_TYPE.Circuit.id)) {
            var newCircuitDataItem = [...circuitDataItem];
            var deleteCircuitItem = newCircuitDataItem.filter((item, i) => i !== index);

            var newCircuitDataTable = [{
                dataItem: deleteCircuitItem,
                HeaderItem: HeaderItem,
            }];
        }
        else if (parseInt(outputScope) === parseInt(RECHARGE_INVENTORY_TYPE.Equipment.id)) {
            var newEquipmentDataItem = [...equipmentDataItem]
            var deleteEquipmentItem = newEquipmentDataItem.filter((item, i) => i !== index);

            var newEquipmentDataTable = [{
                dataItem: deleteEquipmentItem,
                HeaderItem: HeaderItem,
            }];
        }
        else {
            var newOtcDataItem = [...otcDataItem]
            var deleteOtcItem = newOtcDataItem.filter((item, i) => i !== index);

            var newOtcDataTable = [{
                dataItem: deleteOtcItem,
                HeaderItem: HeaderItem,
            }]
        }

        if (parseInt(outputScope) === parseInt(RECHARGE_INVENTORY_TYPE.Circuit.id)) {
            dispatch({
                type: deleteOutputScopeData,
                circuitDataTable: newCircuitDataTable ?? [],
            });
        }
        else if (parseInt(outputScope) === parseInt(RECHARGE_INVENTORY_TYPE.Equipment.id)) {
            dispatch({
                type: deleteOutputScopeData,
                equipmentDataTable: newEquipmentDataTable ?? []
            });
        }
        else {
            dispatch({
                type: deleteOutputScopeData,
                otcDataTable: newOtcDataTable ?? []
            });
        }
    },

    saveOutputConfiguration: (outputConfigId, validate, outputScopeFilter) => async (dispatch, state) => {
        const { outputConfiguration } = state().form.outputConfigurationDetailsForm;
        const { circuitDataTable, equipmentDataTable, otcDataTable, outputColumnsDatatable, multipleOutputColumnsDatatable } = state().outputConfigurationDetails

        try {
            var detailsForm = {
                OutputConfigurationNumber: outputConfiguration.configurationNumber
                , OutputConfigurationName: outputConfiguration.configurationName
                , FileName: outputConfiguration.fileName
                , FileFormatID: outputConfiguration.fileFormatId
                , FileDelimiter: outputConfiguration.fileDelimeter
                , GenerateJsonFile: outputConfiguration.isGenerateJsonFile === "true"
                , CurrencyID: parseInt(outputConfiguration.currencyId)
            }

            var convertTypeoutputScopeCircuit = (circuitDataTable.dataTable[0]?.dataItem ?? []).map((item) => ({
                OutputScopeID: item.OutputScopeID
                , FilterID: item.FilterID
                , OperatorID: item.OperatorID
                , Value: item.Value
                , Date: item.DateValue ? Moment(item.DateValue).format('YYYY-MM-DD') : null
                , OptionID: item.OptionID
                , StartDateValue: item.StartDateValue ? Moment(item.StartDateValue).format('YYYY-MM-DD') : null
                , EndDateValue: item.EndDateValue ? Moment(item.EndDateValue).format('YYYY-MM-DD') : null
                , LastModified: item.LastModified
            }));

            var convertTypeoutputScopeEquipment = (equipmentDataTable.dataTable[0]?.dataItem ?? []).map((item) => ({
                OutputScopeID: item.OutputScopeID
                , FilterID: item.FilterID
                , OperatorID: item.OperatorID
                , Value: item.Value
                , Date: item.DateValue ? Moment(item.DateValue).format('YYYY-MM-DD') : null
                , OptionID: item.OptionID
                , StartDateValue: item.StartDateValue ? Moment(item.StartDateValue).format('YYYY-MM-DD') : null
                , EndDateValue: item.EndDateValue ? Moment(item.EndDateValue).format('YYYY-MM-DD') : null
                , LastModified: item.LastModified
            }));

            var convertTypeoutputScopeOtc = (otcDataTable.dataTable[0]?.dataItem ?? []).map((item) => ({
                OutputScopeID: item.OutputScopeID
                , FilterID: item.FilterID
                , OperatorID: item.OperatorID
                , Value: item.Value
                , Date: item.DateValue ? Moment(item.DateValue).format('YYYY-MM-DD') : null
                , OptionID: item.OptionID
                , StartDateValue: item.StartDateValue ? Moment(item.StartDateValue).format('YYYY-MM-DD') : null
                , EndDateValue: item.EndDateValue ? Moment(item.EndDateValue).format('YYYY-MM-DD') : null
                , LastModified: item.LastModified
            }));

            var convertTypeoutputColumn = (outputColumnsDatatable.dataTable?.[0]?.dataItem ?? []).map((item) => ({
                OutputColumnID: item.OutputColumnID,
                ColumnSourceID: item.ColumnSourceID,
                ColumnFormatID: item.ColumnFormatID,
                ColumnName: toPascalCase(item.ColumnName || ''),
                Values: item.Values,
                SortOrder: item.SortOrder,
                LastModified: item.LastModified
            }));

            const convertToNullable = (val) => (val === 0 || val === null ? null : val);

            const convertTypeMultipleOutputColumn = (multipleOutputColumnsDatatable.dataTable?.[0]?.dataItem ?? []).map((item) => ({
                OutputColumnID: item.OutputColumnID,
                ColumnSourceID1: convertToNullable(item.ColumnSourceID1),
                ColumnFormatID1: convertToNullable(item.ColumnFormatID1),
                ColumnSourceID2: convertToNullable(item.ColumnSourceID2),
                ColumnFormatID2: convertToNullable(item.ColumnFormatID2),
                ColumnSourceID3: convertToNullable(item.ColumnSourceID3),
                ColumnFormatID3: convertToNullable(item.ColumnFormatID3),
                ColumnName: toPascalCase(item.ColumnName || ''),
                Values: item.Values,
                LastModified: item.LastModified
            }));

            var formData = {
                ...detailsForm
                , OutputScopeCircuit: convertTypeoutputScopeCircuit?.length ? convertTypeoutputScopeCircuit : []
                , OutputScopeEquipment: convertTypeoutputScopeEquipment?.length ? convertTypeoutputScopeEquipment : []
                , OutputScopeOTC: convertTypeoutputScopeOtc?.length ? convertTypeoutputScopeOtc : []
                , OutputColumns: convertTypeoutputColumn?.length ? convertTypeoutputColumn : []
                , MultipleOutputColumns: convertTypeMultipleOutputColumn?.length ? convertTypeMultipleOutputColumn : []
            }

            var result = await httpPost(`external/recharge/saveOutputConfiguration/${outputConfigId}/${validate}`, formData)

            if (result.success === false) {
                if (result.propertyName === "OutputConfigurationName") {
                    dispatch(actions.setErrors('outputConfigurationDetailsForm.outputConfiguration.configurationName', true));
                }
                else if (result.propertyName === "OutputColumns") {
                    dispatch(actions.setErrors('outputConfigurationDetailsForm.outputColumnScope', true));
                }
            }
        }
        catch (e) {
            return e;
        }
        return result;
    },

    setConfigNumber: (configNumber) => async (dispatch) => {
        if (configNumber) {
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.configurationNumber', configNumber));
        }
    },

    setFileDelimiter: (model, value) => (dispatch, state) => {

        if (parseInt(value) === FILE_DELIMITER.csv.id) {
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileFormatId', FILE_DELIMITER.csv.id));
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileDelimeter', FILE_DELIMITER.csv.delimiter));
        }
        else if (parseInt(value) === FILE_DELIMITER.txt.id) {
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileFormatId', FILE_DELIMITER.txt.id));
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileDelimeter', FILE_DELIMITER.txt.delimeter))
        }
        else {
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileFormatId', FILE_DELIMITER.xls.id))
            dispatch(actions.change('outputConfigurationDetailsForm.outputConfiguration.fileDelimeter', FILE_DELIMITER.xls.delimiter))
        }
    },

    filterOperatorOptions: (model, value, outputScope) => (dispatch, state) => {

        const { filterType, filterOperator } = getSearchOperators(outputScope, value, state);

        if (outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope.Value'))
            dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope.DateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope.StartDateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope.EndDateValue'))
        }
        else if (outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope.Value'))
            dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope.DateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope.StartDateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope.EndDateValue'))
        }
        else {
            dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope.Value'))
            dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope.DateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope.StartDateValue'))
            dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope.EndDateValue'))
        }

        dispatch(actions.change(model, value))

        if (filterOperator) {
            dispatch({
                type: filterOperatorByType
                , filterOperatorOptions: filterOperator
                , filterType: filterType
            })
        }
    
    },

    filterColumnFormat: (model, value) => (dispatch, state) => {
        const { ColumnFormat, OutputColumnSource } = state().outputConfigurationDetails.outputConfigurationDropdownlist;

        const findColumnFormatType = OutputColumnSource.find(f => parseInt(f.ColumnSourceID) === parseInt(value));
        const filterTypeId = findColumnFormatType ? findColumnFormatType.DataTypeID : null;

        var filterColumnFormat = ColumnFormat.filter(op => parseInt(op.DataTypeID) === parseInt(filterTypeId));
        if (parseInt(value) === 31) {
            dispatch(actions.change('outputConfigurationDetailsForm.outputColumnScope.ColumnFormatID', 0))
        }
        else {
            if (parseInt(filterTypeId) === parseInt(COLUMN_DATA_TYPE.text.id)) {
                dispatch(actions.change('outputConfigurationDetailsForm.outputColumnScope.ColumnFormatID', COLUMN_DATA_TYPE.text.defaultId))
            }
            else if (parseInt(filterTypeId) === parseInt(COLUMN_DATA_TYPE.date.id)) {
                dispatch(actions.change('outputConfigurationDetailsForm.outputColumnScope.ColumnFormatID', COLUMN_DATA_TYPE.date.defaultId))
            }
            else {
                dispatch(actions.change('outputConfigurationDetailsForm.outputColumnScope.ColumnFormatID', COLUMN_DATA_TYPE.decimal.defaultId))
            }
        }


        dispatch(actions.change(model, value))
        dispatch({
            type: filterColumnFormatByType
            , filterColumnFormat: filterColumnFormat
        })

    },

    filterColumnFormatByIndex: (index, model, value) => (dispatch, state) => {
        const { ColumnFormat, OutputColumnSource } = state().outputConfigurationDetails.outputConfigurationDropdownlist;

        const parsedIndex = parseInt(index);
        const findColumnFormatType = OutputColumnSource.find(f => parseInt(f.ColumnSourceID) === parseInt(value));
        const filterTypeId = findColumnFormatType ? findColumnFormatType.DataTypeID : null;

        const filteredFormats = ColumnFormat.filter(op => parseInt(op.DataTypeID) === parseInt(filterTypeId));

        // Default format ID based on type
        let defaultFormatId;
        if (parseInt(filterTypeId) === parseInt(COLUMN_DATA_TYPE.text.id)) {
            defaultFormatId = COLUMN_DATA_TYPE.text.defaultId;
        } else if (parseInt(filterTypeId) === parseInt(COLUMN_DATA_TYPE.date.id)) {
            defaultFormatId = COLUMN_DATA_TYPE.date.defaultId;
        } else {
            defaultFormatId = COLUMN_DATA_TYPE.decimal.defaultId;
        }

        // Dispatch format ID to the appropriate field
        dispatch(actions.change(`outputConfigurationDetailsForm.multipleOutputColumnScope.ColumnFormatID${parsedIndex}`, defaultFormatId));

        // Update the ColumnSourceID
        dispatch(actions.change(model, value));

        // Dispatch the filtered format list with correct constant type
        const typeMap = {
            1: filterMultipleColumn1FormatByType,
            2: filterMultipleColumn2FormatByType,
            3: filterMultipleColumn3FormatByType
        };

        const payloadKeyMap = {
            1: 'filterColumn1Format',
            2: 'filterColumn2Format',
            3: 'filterColumn3Format'
        };

        const actionType = typeMap[parsedIndex];
        const payloadKey = payloadKeyMap[parsedIndex];

        if (actionType && payloadKey) {
            dispatch({
                type: actionType,
                [payloadKey]: filteredFormats
            });
        }
    },

    handleResetForm: (outputScope) => (dispatch) => {
        if (outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope'))
        }
        else if (outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope'))
        }
        else if (outputScope === RECHARGE_INVENTORY_TYPE.OTC.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope'))
        }
        else if (outputScope === OUTPUT_COLUMN_TYPE.MultipleOutputColumn.id) {
            dispatch(actions.reset('outputConfigurationDetailsForm.multipleOutputColumnScope'))
        }
        else {
            dispatch(actions.reset('outputConfigurationDetailsForm.outputColumnScope'))
        }
    },

    updateOutputColumnsDatatable: (data) => (dispatch) => {
        const newOutputDataTable = [
            {
                dataItem: data,
                HeaderItem: []
            }
        ];

        dispatch({
            type: updateOutputColumnsDatatable,
            outputColumnsDatatable: newOutputDataTable
        });
    },

    resetAllForm: () => (dispatch) => {
        dispatch(actions.reset('outputConfigurationDetailsForm.circuitOutputScope'))
        dispatch(actions.reset('outputConfigurationDetailsForm.equipmentOutputScope'))
        dispatch(actions.reset('outputConfigurationDetailsForm.otcOutputScope'))
        dispatch(actions.reset('outputConfigurationDetailsForm.outputColumnScope'))
        dispatch(actions.reset('outputConfigurationDetailsForm.multipleOutputColumnScope'))

        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.configurationName'));
        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.fileName'));
        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.fileFormatId'));
        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.fileDelimeter'));
        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.isGenerateJsonFile'));
        dispatch(actions.reset('outputConfigurationDetailsForm.outputConfiguration.currencyId'));


        dispatch({
            type: resetDataTable
            , dataTable: []
        })
    },

    resetDateField: (model, value, outputScope) => (dispatch) => {
        const scopeMap = {
            [RECHARGE_INVENTORY_TYPE.Circuit.id]: 'circuitOutputScope',
            [RECHARGE_INVENTORY_TYPE.Equipment.id]: 'equipmentOutputScope',
            [RECHARGE_INVENTORY_TYPE.OTC.id]: 'otcOutputScope'
        };

        const scopeKey = scopeMap[outputScope];

        if (!scopeKey) return;

        const formPath = `outputConfigurationDetailsForm.${scopeKey}`;

        dispatch(actions.reset(`${formPath}.DateValue`));
        dispatch(actions.reset(`${formPath}.StartDateValue`));
        dispatch(actions.reset(`${formPath}.EndDateValue`));
        dispatch(actions.change(model, value));
    },

    addUpdateOutputColumn: () => (dispatch, state) => {
        const { outputConfigurationDropdownlist, outputColumnsDatatable, multipleOutputColumnsDatatable } = state().outputConfigurationDetails;
        const { OutputColumnSource, ColumnFormat } = outputConfigurationDropdownlist;
        const { outputColumnScope, multipleOutputColumnScope } = state().form.outputConfigurationDetailsForm;
        const { ID, ColumnSourceID, ColumnFormatID } = outputColumnScope;
        const { activeTimeZoneOffset } = state().adminSetting;

        const isMultipleSource = parseInt(ColumnSourceID) === 31;

        const column = OutputColumnSource.find(x => x.ColumnSourceID === parseInt(ColumnSourceID));
        const columnFormat = ColumnFormat.find(x => x.ColumnSourceID === parseInt(ColumnFormatID));

        let multipleValues = multipleOutputColumnScope.Values || "";

        if (isMultipleSource) {
            for (let i = 1; i <= 3; i++) {
                const key = `ColumnSourceID${i}`;
                const columnSourceID = parseInt(multipleOutputColumnScope[key]);

                if (!isNaN(columnSourceID)) {
                    const matchedSource = OutputColumnSource.find(x => x.ColumnSourceID === columnSourceID);
                    const replacement = matchedSource?.ColumnName || "";

                    // Replace [column source i] (case-insensitive, global)
                    const placeholderPattern = new RegExp(`\\[column source ${i}\\]`, 'gi');
                    multipleValues = multipleValues.replace(placeholderPattern, `[${replacement}]`);
                }
            }
        }

        const now = Moment();
        const formattedNow = `${now.format('L')} ${now.format('LT')}`;
        const lastModified = `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`;

        const existingData = outputColumnsDatatable?.dataTable?.[0]?.dataItem || [];
        const existingMultipleData = multipleOutputColumnsDatatable?.dataTable?.[0]?.dataItem || [];

        let updatedScopeData = [...existingData];
        let updatedMultipleScopeData = [...existingMultipleData];

        const maxSortOrder = existingData.reduce((max, item) => item.SortOrder > max ? item.SortOrder : max, 0);

        const newItem = {
            ...outputColumnScope,
            ID: -1,
            ColumnSourceID: parseInt(ColumnSourceID),
            ColumnSource: column?.ColumnName || "",
            ColumnName: isMultipleSource ? toPascalCase(multipleOutputColumnScope.ColumnName || '') : toPascalCase(outputColumnScope.ColumnName || ''),
            ColumnFormatID: parseInt(ColumnFormatID),
            ColumnFormat: columnFormat?.ColumnName || "",
            Values: isMultipleSource ? multipleValues : outputColumnScope.Values,
            CreatedByUserID: sessionStorage.getItem('UserRoleID'),
            CreatedDate: formattedNow,
            LastModified: lastModified,
            SortOrder: ID >= 0 && existingData.find(x => x.OutputColumnID === outputColumnScope.OutputColumnID)
                ? existingData.find(x => x.OutputColumnID === outputColumnScope.OutputColumnID).SortOrder
                : maxSortOrder + 1,
            OutputColumnID: ID >= 0 && outputColumnScope.OutputColumnID >= 0
                ? outputColumnScope.OutputColumnID
                : -1
        };

        // Replace or push OutputColumn
        if (ID >= 0 && updatedScopeData[ID]) {
            updatedScopeData[ID] = newItem;
        } else {
            updatedScopeData.push(newItem);
        }

        const sortedUnified = updatedScopeData.sort((a, b) => a.SortOrder - b.SortOrder);
        const newUnifiedTable = [{ dataItem: sortedUnified, headerItem: [] }];

        if (isMultipleSource) {
            const newMultipleItem = {
                ...multipleOutputColumnScope,
                ID: -1,
                ColumnSourceID1: parseInt(multipleOutputColumnScope.ColumnSourceID1),
                ColumnFormatID1: parseInt(multipleOutputColumnScope.ColumnFormatID1),
                ColumnSourceID2: parseInt(multipleOutputColumnScope.ColumnSourceID2),
                ColumnFormatID2: parseInt(multipleOutputColumnScope.ColumnFormatID2),
                ColumnSourceID3: parseInt(multipleOutputColumnScope.ColumnSourceID3),
                ColumnFormatID3: parseInt(multipleOutputColumnScope.ColumnFormatID3),
                ColumnSource1: OutputColumnSource.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnSourceID1))?.ColumnName || "",
                ColumnFormat1: ColumnFormat.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnFormatID1))?.ColumnName || "",
                ColumnSource2: OutputColumnSource.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnSourceID2))?.ColumnName || "",
                ColumnFormat2: ColumnFormat.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnFormatID2))?.ColumnName || "",
                ColumnSource3: OutputColumnSource.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnSourceID3))?.ColumnName || "",
                ColumnFormat3: ColumnFormat.find(x => x.ColumnSourceID === parseInt(multipleOutputColumnScope.ColumnFormatID3))?.ColumnName || "",
                ColumnName: toPascalCase(multipleOutputColumnScope.ColumnName || ''),
                Values: multipleOutputColumnScope.Values,
                CreatedByUserID: sessionStorage.getItem('UserRoleID'),
                CreatedDate: formattedNow,
                LastModified: lastModified,
                SortOrder: newItem.SortOrder,
                OutputColumnID: newItem.OutputColumnID
            };

            if (ID >= 0 && updatedMultipleScopeData[ID]) {
                updatedMultipleScopeData[ID] = newMultipleItem;
            } else {
                updatedMultipleScopeData.push(newMultipleItem);
            }

            const newMultipleTable = [{ dataItem: updatedMultipleScopeData, headerItem: [] }];

            dispatch({
                type: addUpdateOutputColumnItem,
                outputColumnsDatatable: newUnifiedTable,
                multipleOutputColumnsDatatable: newMultipleTable,
                filterColumnFormat: []
            });
        }
        else {
            dispatch({
                type: addUpdateOutputColumnItem,
                outputColumnsDatatable: newUnifiedTable,
                filterColumnFormat: []
            });
        }
    },

    viewOutputColumn: (index, dataTable) => async (dispatch, state) => {
        const { outputConfigurationDropdownlist } = state().outputConfigurationDetails;
        const { ColumnFormat, OutputColumnSource } = outputConfigurationDropdownlist;

        const data = dataTable[0][index];
        const findColumnFormatType = OutputColumnSource.find(f => f.ColumnSourceID === parseInt(data.ColumnSourceID));
        const filterTypeId = findColumnFormatType ? findColumnFormatType.DataTypeID : null;

        const filterColumnFormat = ColumnFormat.filter(op => op.DataTypeID === filterTypeId);

        const dataItem = {
            ...data,
            ID: index
        };

        dispatch(actions.reset("outputConfigurationDetailsForm.outputColumnScope"));
        dispatch(actions.change("outputConfigurationDetailsForm.outputColumnScope", dataItem));

        dispatch({
            type: filterColumnFormatByType,
            filterColumnFormat
        });

        return dataItem;
    },

    viewMulitpleOutputColumn: (index, dataTable) => async (dispatch, state) => {
        const { outputConfigurationDropdownlist } = state().outputConfigurationDetails;
        const { ColumnFormat, OutputColumnSource } = outputConfigurationDropdownlist;

        const data = dataTable[0][index];

        const getFormatListBySource = (columnSourceID) => {
            const source = OutputColumnSource.find(f => f.ColumnSourceID === parseInt(columnSourceID));
            const typeId = source?.DataTypeID ?? null;
            return ColumnFormat.filter(format => format.DataTypeID === typeId);
        };

        // Get all 3 filtered format lists
        const filterColumn1Format = getFormatListBySource(data.ColumnSourceID1);
        const filterColumn2Format = getFormatListBySource(data.ColumnSourceID2);
        const filterColumn3Format = getFormatListBySource(data.ColumnSourceID3);

        // Build the form-bound data item
        const dataItem = {
            ...data,
            ID: index
        };

        // Dispatch form update and filtered formats
        dispatch(actions.reset("outputConfigurationDetailsForm.multipleOutputColumnScope"));
        dispatch(actions.change("outputConfigurationDetailsForm.multipleOutputColumnScope", dataItem));

        dispatch({
            type: filterMultipleColumn1FormatByType,
            filterColumn1Format
        });
        dispatch({
            type: filterMultipleColumn2FormatByType,
            filterColumn2Format
        });
        dispatch({
            type: filterMultipleColumn3FormatByType,
            filterColumn3Format
        });

        return dataItem;
    },

    deleteOutputColumnData: (index, dataTable) => (dispatch, state) => {
        const { outputColumnsDatatable } = state().outputConfigurationDetails;

        const currentData = outputColumnsDatatable?.dataTable?.[0]?.dataItem || [];

        // Delete by index directly
        const updatedData = currentData.filter((_, idx) => idx !== index);

        // Re-assign sort order to maintain consistency
        const reSortedData = updatedData.map((item, idx) => ({
            ...item,
            SortOrder: idx + 1
        }));

        const newDataTable = [
            {
                dataItem: reSortedData,
                HeaderItem: outputColumnsDatatable?.dataTable?.[0]?.HeaderItem || []
            }
        ];


        dispatch({
            type: deleteOutputColumnData,
            outputColumnsDatatable: newDataTable
        });
    },

    getOutputConfigurationDetailsForm: (outputConfigurationId) => async (dispatch, state) => {
        var res = await httpGet(`external/recharge/getOutputConfigurationDetails/${outputConfigurationId}`);

        var data = res.data

        if (data) {
            batch(() => {
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.outputConfigurationId', data.OutputConfigurationID));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.configurationNumber', data.OutputConfigurationNumber));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.configurationName', data.OutputConfigurationName));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.fileName', data.FileName));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.fileFormatId', data.FileFormatID));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.fileDelimeter', data.FileDelimiter));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.isGenerateJsonFile', data.GenerateJsonFile.toString()));
                dispatch(actions.load('outputConfigurationDetailsForm.outputConfiguration.currencyId', data.CurrencyID));

                const convertedOutputScopeCircuitList = data.OutputScopeCircuit.map(item =>{
                    const convertedItem = { ...item };

                    convertedItem.Date = item.Date != null ? new Date(item.Date) : null;

                    const startDate = item.StartDateValue != null ? new Date(item.StartDateValue) : null;
                    const endDate = item.EndDateValue != null ? new Date(item.EndDateValue) : null;

                    convertedItem.StartDateValue = startDate;
                    convertedItem.EndDateValue = endDate;

                    if(startDate && endDate){
                        convertedItem.Date = startDate + " - " + endDate                   
                    }

                    return convertedItem;
                })

                const convertedOutputScopeEquipmentList = data.OutputScopeEquipment.map(item =>{
                    const convertedItem = { ...item };

                    convertedItem.Date = item.Date != null ? new Date(item.Date) : null;

                    const startDate = item.StartDateValue != null ? new Date(item.StartDateValue) : null;
                    const endDate = item.EndDateValue != null ? new Date(item.EndDateValue) : null;

                    convertedItem.StartDateValue = startDate;
                    convertedItem.EndDateValue = endDate;

                    if(startDate && endDate){
                        convertedItem.Date = startDate + " - " + endDate                   
                    }

                    return convertedItem;
                })

                const convertedOutputScopeOTCList = data.OutputScopeOTC.map(item =>{
                    const convertedItem = { ...item };

                    convertedItem.Date = item.Date != null ? new Date(item.Date) : null;

                    const startDate = item.StartDateValue != null ? new Date(item.StartDateValue) : null;
                    const endDate = item.EndDateValue != null ? new Date(item.EndDateValue) : null;

                    convertedItem.StartDateValue = startDate;
                    convertedItem.EndDateValue = endDate;

                    if(startDate && endDate){
                        convertedItem.Date = startDate + " - " + endDate                   
                    }

                    return convertedItem;
                })


                dispatch({
                    type: getOutputConfigurationDetails,
                    outputScopeCircuitDatatable: convertedOutputScopeCircuitList,
                    outputScopeEquipmentDatatable: convertedOutputScopeEquipmentList,
                    outputScopeOTCDatatable: convertedOutputScopeOTCList,
                    outputColumnsDatatable: data.OutputColumns,
                    multipleOutputColumnsDatatable: data.MultipleOutputColumns,
                    outputScopeCircuitCount: res.OutputScopeCircuitCount,
                    outputScopeEquipmentCount: res.OutputScopeEquipmentCount,
                    outputScopeOtcCount: res.OutputScopeOtcCount,
                    outputScopeHeaders: res.OutputScopeHeaders,
                    outputColumnsHeaders: res.OutputColumnHeaders
                });
            });
        }
        else {
            dispatch({
                type: getOutputConfigurationDetails,
                outputScopeHeaders: res.OutputScopeHeaders,
                outputColumnsHeaders: res.OutputColumnHeaders
            })
        }
    },

    extractOutputScope: (outputScopeExtractId) => async (dispatch, state) => {            
        const { outputConfiguration } = state().form.outputConfigurationDetailsForm
        const { circuitDataTable, equipmentDataTable, otcDataTable } = state().outputConfigurationDetails
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filenameFilteredWithTab = outputScopeExtractId === OUTPUT_SCOPE_TYPE.circuit.id ? OUTPUT_SCOPE_TYPE.circuit.name :
                                      outputScopeExtractId === OUTPUT_SCOPE_TYPE.equipment.id ? OUTPUT_SCOPE_TYPE.equipment.name : 
                                      outputScopeExtractId === OUTPUT_SCOPE_TYPE.otc.id ? OUTPUT_SCOPE_TYPE.otc.name : null;
        var filename = `ATEM ${dealName} Output Scope - ${filenameFilteredWithTab} Extract – ${formattedTimeZoneDate}`;
        var filterList = outputScopeExtractId === OUTPUT_SCOPE_TYPE.circuit.id ? circuitDataTable?.dataTable?.[0]?.dataItem :
                        outputScopeExtractId === OUTPUT_SCOPE_TYPE.equipment.id ? equipmentDataTable?.dataTable?.[0]?.dataItem : 
                        outputScopeExtractId === OUTPUT_SCOPE_TYPE.otc.id ? otcDataTable?.dataTable?.[0]?.dataItem : null;
        const transformedFilterList = filterList.map(filter => ({
                                    ...filter,
                                    Date: toDateOnly(filter.Date),
                                    StartDateValue: toDateOnly(filter.StartDateValue),
                                    EndDateValue: toDateOnly(filter.EndDateValue),
                                    OperatorName: OPERATOR_FILTER_ENUMS[filter.OperatorName] || filter.OperatorName,
                                }));

        var data = {
            OutputConfigurationID: outputConfiguration.outputConfigurationId,
            OutputScopeTab: outputScopeExtractId,
            FileName: filename,
            TableFilterList: transformedFilterList,
            Headers:null,
            Timezone:null
        };
    
        httpDownload('external/recharge/getOutputConfigurationOutputScope', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
        });
    },

    updateOutputScopeCount: (outputScopeId) => async (dispatch, state) => {           
        const { outputConfiguration } = state().form.outputConfigurationDetailsForm 
        const { circuitDataTable, equipmentDataTable, otcDataTable } = state().outputConfigurationDetails

        var filterList = outputScopeId === OUTPUT_SCOPE_TYPE.circuit.id ? circuitDataTable?.dataTable?.[0]?.dataItem :
                        outputScopeId === OUTPUT_SCOPE_TYPE.equipment.id ? equipmentDataTable?.dataTable?.[0]?.dataItem : 
                        outputScopeId === OUTPUT_SCOPE_TYPE.otc.id ? otcDataTable?.dataTable?.[0]?.dataItem : null;
        const transformedFilterList = filterList.map(filter => ({
                                    ...filter,
                                    Date: toDateOnly(filter.Date),
                                    StartDateValue: toDateOnly(filter.StartDateValue),
                                    EndDateValue: toDateOnly(filter.EndDateValue),
                                    OperatorName: OPERATOR_FILTER_ENUMS[filter.OperatorName] || filter.OperatorName,
                                }));
        var data = {
            OutputConfigurationID: outputConfiguration.outputConfigurationId,
            OutputScopeTab: outputScopeId,
            FileName: null,
            TableFilterList: transformedFilterList,
            Headers:null,
            TimeZone:null
        };
               
        var res = await httpPost('external/recharge/getUpdateOutputScopeCount', data);

        if(res != null){
            dispatch({
                type: getUpdateOutputScopeCount,
                Count: res.Count,
                outputScopeId: outputScopeId,
            });
        }

    },

    checkRecentOutputRecordStatus: (outputConfigurationId) => async (dispatch, state) => {
        var action = await httpGet('external/recharge/checkRecentOutputRecordStatus/' + outputConfigurationId);

        return action.result;
    },

    performOutputGeneration: (outputConfigurationId, isGenerateJSONFile, uploadTypeId) => async (dispatch, state) => {
        try {
            var isGenerateJSONFileInt = isGenerateJSONFile ? 1 : 0;
            var outputRecordIdPrimaryKey = await httpPost('external/recharge/createOutputRecordId/' + outputConfigurationId + '/' + isGenerateJSONFileInt)
            
            var customData = {
                RechargingOutputConfigurationID: outputConfigurationId,
                IsGenerateJSONFile: isGenerateJSONFileInt,
                RechargingOutputRecordID: outputRecordIdPrimaryKey.result
            };

            var data = {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: uploadTypeId,
                State: true,
                ChargeTypeDetails: JSON.stringify({
                    ...customData,
                }),
            };

            var result = await httpPost('external/recharge/generateOutput', data);
            
        }
        catch(e) {
            return e;
        }
        return result;
    }
};

function toDateOnly(date) {
    if (!date) return null;

    // Try parsing if it's already a Date object
    if (date instanceof Date && !isNaN(date)) {
        return date.toISOString().substring(0, 10);
    }

    // Try parsing if it's a string or number
    const parsed = new Date(date);
    if (!isNaN(parsed)) {
        return parsed.toISOString().substring(0, 10);
    }

    // If parsing fails, return null or throw
    console.warn('Invalid date value:', date);
    return null;
}


function getSearchOperators(outputScope, FilterId, state) {
    const { SearchOperator, CircuitColumnSource, EquipmentColumnSource, OtcColumnSource } = state().outputConfigurationDetails.outputConfigurationDropdownlist;

    const getSourceColumn =
        outputScope === RECHARGE_INVENTORY_TYPE.Circuit.id
            ? CircuitColumnSource
            : outputScope === RECHARGE_INVENTORY_TYPE.Equipment.id
                ? EquipmentColumnSource
                : OtcColumnSource;

    const findType = getSourceColumn.find(f => f.FilterId === parseInt(FilterId));
    const filterType = findType ? findType.FilterType : null;

    let filterOperator;

    if (filterType === OPERATOR_FILTERS.textbox.filterType) {
        filterOperator = SearchOperator.filter(op =>
            OPERATOR_FILTERS.textbox.Operators.includes(op.Value))
            .sort((a, b) => a.Value.localeCompare(b.Value));
    }
    else if (filterType === OPERATOR_FILTERS.date.filterType) {
        filterOperator = SearchOperator.filter(op =>
            OPERATOR_FILTERS.date.Operators.includes(op.Value))
            .sort((a, b) => a.Value.localeCompare(b.Value));;
    }
    return { filterType, filterOperator };
}

        

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getOutputConfigurationDropdownlist:
            return {
                ...state
                , isOutputConfigurationDropdownListLoaded: action.isOutputConfigurationDropdownListLoaded
                , outputConfigurationDropdownlist: action.outputConfigurationDropdownlist
            };
        case filterOperatorByType: {
            return {
                ...state
                , filterOperatorOptions: action.filterOperatorOptions
                , filterType: action.filterType
            };
        }
        case filterColumnFormatByType: {
            return {
                ...state
                , filterColumnFormat: action.filterColumnFormat
            };
        }
        case filterMultipleColumn1FormatByType: {
            return {
                ...state
                , filterColumn1Format: action.filterColumn1Format
            };
        }
        case filterMultipleColumn2FormatByType: {
            return {
                ...state
                , filterColumn2Format: action.filterColumn2Format
            };
        }
        case filterMultipleColumn3FormatByType: {
            return {
                ...state
                , filterColumn3Format: action.filterColumn3Format
            };
        }
        case deleteOutputScopeData: {
            return {
                ...state,
                ...(action.circuitDataTable && {
                    circuitDataTable: {
                        ...state.circuitDataTable,
                        dataTable: action.circuitDataTable
                    }
                }),
                ...(action.equipmentDataTable && {
                    equipmentDataTable: {
                        ...state.equipmentDataTable,
                        dataTable: action.equipmentDataTable
                    }
                }),
                ...(action.otcDataTable && {
                    otcDataTable: {
                        ...state.otcDataTable,
                        dataTable: action.otcDataTable
                    }
                })
            };
        }
        case addUpdateScopeItem: {
            return {
                ...state,
                filterOperatorOptions: action.filterOperatorOptions,
                ...(action.circuitDataTable && {
                    circuitDataTable: {
                        ...state.circuitDataTable,
                        dataTable: action.circuitDataTable
                    }
                }),
                ...(action.equipmentDataTable && {
                    equipmentDataTable: {
                        ...state.equipmentDataTable,
                        dataTable: action.equipmentDataTable
                    }
                }),
                ...(action.otcDataTable && {
                    otcDataTable: {
                        ...state.otcDataTable,
                        dataTable: action.otcDataTable
                    }
                })
            }
        }
        case resetDataTable: {
            return {
                ...state,
                circuitDataTable: {
                    ...state.circuitDataTable,
                    dataTable: action.dataTable
                },
                equipmentDataTable: {
                    ...state.equipmentDataTable,
                    dataTable: action.dataTable
                },
                otcDataTable: {
                    ...state.otcDataTable,
                    dataTable: action.dataTable
                },
                outputColumnsDatatable: {
                    ...state.outputColumnsDatatable,
                    dataTable: action.dataTable
                },
                multipleOutputColumnsDatatable: {
                    ...state.multipleOutputColumnsDatatable,
                    dataTable: action.dataTable
                }
            };
        }
        case addUpdateOutputColumnItem: {
            return {
                ...state,
                filterColumnFormat: action.filterColumnFormat,
                ...(action.outputColumnsDatatable && {
                    outputColumnsDatatable: {
                        ...state.outputColumnsDatatable,
                        dataTable: action.outputColumnsDatatable
                    }
                }),
                ...(action.multipleOutputColumnsDatatable && {
                    multipleOutputColumnsDatatable: {
                        ...state.multipleOutputColumnsDatatable,
                        dataTable: action.multipleOutputColumnsDatatable
                    }
                })
            };
        }
        case deleteOutputColumnData: {
            return {
                ...state,
                ...(action.outputColumnsDatatable && {
                    outputColumnsDatatable: {
                        ...state.outputColumnsDatatable,
                        dataTable: action.outputColumnsDatatable
                    }
                })
            };
        }
        case updateOutputColumnsDatatable: {
            return {
                ...state,
                ...(action.outputColumnsDatatable && {
                    outputColumnsDatatable: {
                        ...state.outputColumnsDatatable,
                        dataTable: action.outputColumnsDatatable
                    }
                })
            };
        }
        case getOutputConfigurationDetails:
            return {
                ...state
                , outputScopeCircuitDatatable: action.outputScopeCircuitDatatable
                , outputScopeEquipmentDatatable: action.outputScopeEquipmentDatatable
                , outputScopeOTCDatatable: action.outputScopeOTCDatatable
                , outputScopeCircuitCount: action.outputScopeCircuitCount
                , outputScopeEquipmentCount: action.outputScopeEquipmentCount
                , outputScopeOtcCount: action.outputScopeOtcCount
                , outputScopeHeaders: action.outputScopeHeaders
                , outputColumnsHeaders: action.outputColumnsHeaders
                , circuitDataTable :{
                    dataTable: [{
                        dataItem: action.outputScopeCircuitDatatable
                    }]
                }
                , equipmentDataTable :{
                    dataTable: [{
                        dataItem: action.outputScopeEquipmentDatatable
                    }]
                }
                , otcDataTable :{
                    dataTable: [{
                        dataItem: action.outputScopeOTCDatatable
                    }]
                }
                , outputColumnsDatatable :{
                    dataTable: [{
                        dataItem: action.outputColumnsDatatable
                    }]
                }
                , multipleOutputColumnsDatatable: {
                    dataTable: [{
                        dataItem: action.multipleOutputColumnsDatatable
                    }]
                }
            };
        case getUpdateOutputScopeCount: {
            let updatedState = { ...state };

            switch (action.outputScopeId) {
                case OUTPUT_SCOPE_TYPE.circuit.id:
                    updatedState.outputScopeCircuitCount = action.Count;
                    break;
                case OUTPUT_SCOPE_TYPE.equipment.id:
                    updatedState.outputScopeEquipmentCount = action.Count;
                    break;
                case OUTPUT_SCOPE_TYPE.otc.id:
                    updatedState.outputScopeOtcCount = action.Count;
                    break;
                default:
                    break;
            }
            return updatedState;
        }
        default:
            return state;
    }
}